import { useMemo } from "react";
import { useHotel } from "@/hooks/useHotel";
import { useRequests } from "@/components/pages/requests/hooks/useRequests";
import { useAccessCapabilities } from "@/hooks/useAccessCapabilities";
import {
  buildDashboardGuestRequestsListFilters,
  countGuestRequestsCompletedToday,
  countGuestRequestsCreatedToday,
} from "@/components/pages/dashboard/utils/dashboardGuestRequests";

export const useDashboardGuestRequestMetrics = () => {
  const { hotelId } = useHotel();
  const { capabilities } = useAccessCapabilities();
  const filters = useMemo(
    () => (hotelId ? buildDashboardGuestRequestsListFilters(hotelId) : null),
    [hotelId],
  );

  const { data, isLoading } = useRequests(
    filters ?? undefined,
    Boolean(filters) && capabilities.canUseRequestsSystem,
  );

  return useMemo(() => {
    if (!capabilities.canUseRequestsSystem) {
      return {
        isLoading: false,
        totalToday: 0,
        completedTodayCount: 0,
      };
    }

    const list = data?.data ?? [];
    return {
      isLoading,
      totalToday: countGuestRequestsCreatedToday(list),
      completedTodayCount: countGuestRequestsCompletedToday(list),
    };
  }, [capabilities.canUseRequestsSystem, data, isLoading]);
};
